import React, { type FC } from "react";
import { reportError } from "@app/services/error-reporter";
import { BusinessList } from "@src/components/business-list";
import { BusinessLotValue } from "@src/components/business-data-display";
import type { ApiStockLot } from "../../../../../../api/lots";
import type { StockGatheringReserveItem } from "../../../../../../api/stockGatherings";
import { StockGatheringCompletionReserveListItem } from "../StockGatheringCompletionReservesList/StockGatheringCompletionReserveListItem";
import "./StockGatheringCompletionReservePickContent.scss";

/** Пропсы окна выбора резерва при неоднозначном скане партии. */
export interface StockGatheringCompletionReservePickContentProps {
    /** Партия, найденная по скану. */
    lot: ApiStockLot;
    /** Резервы КВ, относящиеся к этой партии. */
    reserves: StockGatheringReserveItem[];
    /**
     * Выбор резерва (закрытие overlay — у opener через `OverlayHandle`).
     * @param reserveCode код выбранного резерва
     */
    onSelect: (reserveCode: number) => void | Promise<void>;
}

/** Список кандидатов при неоднозначном скане партии → резерв КВ. */
export const StockGatheringCompletionReservePickContent: FC<StockGatheringCompletionReservePickContentProps> = ({
    lot,
    reserves,
    onSelect,
}) => (
    <div className="stock_gathering_completion_reserve_pick">
        <p className="stock_gathering_completion_reserve_pick__hint">
            По партии найдено несколько резервов. Выберите нужный.
        </p>
        <div className="stock_gathering_completion_reserve_pick__lot">
            <span className="stock_gathering_completion_reserve_pick__lot-label">Партия</span>
            <BusinessLotValue lot={lot} />
        </div>
        <BusinessList>
            {reserves.map((reserve) => (
                <StockGatheringCompletionReserveListItem
                    key={reserve.Code}
                    reserve={reserve}
                    onSelect={(reserveCode) => {
                        Promise.resolve(onSelect(reserveCode)).catch((error) =>
                            reportError(error, { from: "stock.gatheringCompletion.reservePick.select" }),
                        );
                    }}
                />
            ))}
        </BusinessList>
    </div>
);
